module.exports = __webpack_public_path__ + "img/00053.e51337c5.webp";